import { useMutation } from '@tanstack/react-query'

import { axios } from '@apps-common/lib'
import { toastError, toastSuccess } from '@apps-common/lib/toast'
import { ISiteNamedUserModel } from '@apps-common/types/portal/users'

export const updateSystemUser = async (model: ISiteNamedUserModel, image: any): Promise<ISiteNamedUserModel> =>
  new Promise((resolve, reject) => {
    axios
      .post(`/my-monitoring/sites/UpdateSystemUser`, model)
      .then((res) => {
        if (image) {
          const fileData = new FormData()

          fileData.append('file', image?.blob || image)
          axios
            .post(
              `/my-monitoring/sites/UploadSystemUserImg?unitId=${res?.data?.data?.unitId}&namedUserId=${res?.data?.data?.unitNamedUserId}`,
              fileData
            )
            .then((imageRes) => resolve(imageRes?.data?.data))
            .catch((err) => reject(err))
        } else {
          resolve(res?.data?.data)
        }
      })
      .catch((err) => reject(err))
  })

type Props = {
  model: ISiteNamedUserModel
  image?: any
}

export const useMyMonitoringUpdateSystemUser = (notify?: boolean, onSuccess?: (data: ISiteNamedUserModel) => void) =>
  useMutation({
    mutationKey: ['updateMyMonitoringSystemUser'],
    mutationFn: ({ model, image }: Props) => updateSystemUser(model, image),
    onSuccess: (data) => {
      if (onSuccess) {
        onSuccess(data)
      }
      if (notify) {
        toastSuccess('Updated user.')
      }
    },
    onError: (error) => {
      if (notify) {
        toastError(error?.message || 'Failed to update user.')
      }
    },
    throwOnError: false
  })
